
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Mail, HelpCircle } from 'lucide-react';
import { useAccessibility } from '../hooks/useAccessibility';
import { ScrollReveal } from '../components/ScrollReveal';

const Suporte = () => {
  const { speak } = useAccessibility();

  const canalSuporte = {
    icon: Mail,
    nome: 'E-mail',
    descricao: 'Para dúvidas, sugestões ou suporte técnico',
    tempo: 'Resposta em até 24h',
    contato: 'gp.ticam@ifap.edu.br',
    cor: 'bg-blue-100 text-blue-700'
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-16 pb-14 md:pt-20 md:pb-16 bg-background overflow-hidden">
        <div
          className="absolute inset-0 pointer-events-none opacity-[0.35] dark:opacity-[0.12]"
          style={{ backgroundImage: 'radial-gradient(rgb(var(--primary)) 1px, transparent 1px)', backgroundSize: '26px 26px' }}
          aria-hidden="true"
        />
        <div
          className="absolute -top-24 -right-24 w-96 h-96 rounded-full opacity-25 blur-3xl pointer-events-none"
          style={{ background: 'radial-gradient(circle, rgb(var(--primary)) 0%, transparent 70%)' }}
          aria-hidden="true"
        />

        <div className="relative container mx-auto px-4">
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-primary/10 dark:bg-primary/15 px-3 py-1.5 rounded-full text-sm font-semibold text-foreground mb-6">
              <HelpCircle className="w-4 h-4 text-primary-ink dark:text-primary-tint" />
              Central de Suporte
            </div>

            <h1 className="text-4xl md:text-6xl font-bold text-foreground mb-6 leading-[1.1]">
              Como podemos <span className="text-primary">ajudar</span>?
            </h1>

            <p className="font-body text-lg md:text-xl text-muted-foreground leading-relaxed">
              Tem alguma dúvida ou precisa de suporte técnico? Fale com a gente por e-mail.
            </p>
          </div>
        </div>
      </section>

      {/* Canal de Suporte */}
      <ScrollReveal>
      <section className="py-16 bg-secondary/30">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-foreground mb-8 text-center">
            Canal de Atendimento
          </h2>

          <div className="max-w-sm mx-auto">
            <div className="rounded-[1.75rem] p-6 text-center hover:shadow-xl transition-shadow bg-primary/[0.05] dark:bg-primary/[0.1]">
              <div className={`w-16 h-16 ${canalSuporte.cor} rounded-full flex items-center justify-center mx-auto mb-4`}>
                <canalSuporte.icon className="w-8 h-8" />
              </div>
              <h3 className="font-semibold text-foreground text-lg mb-2">{canalSuporte.nome}</h3>
              <p className="text-muted-foreground text-sm mb-2">{canalSuporte.descricao}</p>
              <p className="text-primary text-sm font-medium mb-3">{canalSuporte.tempo}</p>
              <p className="text-foreground font-mono text-sm">{canalSuporte.contato}</p>

              <a
                href={`mailto:${canalSuporte.contato}`}
                className="mt-4 block w-full bg-primary/5 hover:bg-primary/10 text-primary font-medium py-2 rounded-lg transition-colors"
                onClick={() => speak('Entrar em contato por e-mail')}
              >
                Entrar em Contato
              </a>
            </div>
          </div>
        </div>
      </section>
      </ScrollReveal>

      <Footer />
    </div>
  );
};

export default Suporte;
